export default {
    errorCodes: {
        internalErrorOccurred: 0,
        waitForTicketActionCanceledByUser: 7,
        noLoggedInUser: 8,
        sessionRejectedByServer: 9,
        approvalExpired: 14,
        authExpired: 11,
        authSessionExpired: 12,
        invalidOtp: 1,
        assertionCode: 5,
        httpErrorCode: 6
    },
    responseCodes: {
        success: '0000',
        error: '0001',
        userCanceled: '0004',
        failure: '0005',
        approvalExpired: '0006',
        invalidBslToken: '0008'
    },
    responseDesc: {
        success: 'Success',
        userCanceled: 'User Cancelled Authentication.',
        getNewLink: 'getNewLink',
        approvalExpired: 'Auth session Expired',
        systemError: 'System Error',
        applicationError: 'Application Error',
        failure: 'Authentication Failure'
    },
    authenticationStatus: {
        success: 'S',
        failure: 'F',
        userCanceled: 'C',
        systemError: 'E',
        approvalExpired: 'T'
    },
    policyResponse: {
        success: '0',
        applicationError: '5001',
        systemError: '5002',
        invalidformOutput: '1402',
        authFailure: '1409',
        tokenInvalid: '1407',
        invalidBslToken: 6
    },
    endpoints: {
        securelink_qa: 'securelink-dev.syf.com/xm/server',
        securelink_stg: 'securelink-stg.syf.com/xm/server',
        securelink: 'securelink.syf.com/xm/server',
        stg: 'secureaccess-stg.syf.com/xm/server',
        prod: 'secureaccess.syf.com/xm/server',
        qa: 'secureaccess-dev.syf.com/xm/server',
        devapigee: 'api-dev.prvcld.syfbank.com',
        stgapigee: 'api-stg.syf.com',
        prodapigee: 'api.syf.com',
        qaapigee: 'api-qa.syf.com',
        default: 'eisaaas-qa.glb.syfbank.com:443',
        qa_proxy: 'eisaaas-qa.glb.syfbank.com:443',
        stg_proxy: 'eisaaas-stg.glb.syfbank.com:443',
        prod_proxy: 'eisaaas.glb.syfbank.com:443',
        defaultApigee: 'api-des.prvcld.syfbank.com'
    },
    authenticator: {
        instantauth: 'instantauth',
        instantlink: 'instantlink',
        otp: 'otp',
        payfoneverify: 'payfoneverify',
        iovationcheck: 'iovationcheck',
        iovationbind: 'iovationbind',
        devicebinding: 'devicebinding',
        trustscore: 'trustscore',
        truststamp: 'truststamp',
        ts: 'ts',
        masterfraud: 'masterfraud',
        op: 'op',
        enterphonenumber: 'enterphonenumber',
        OTP: 'OTP',
        phoneconfirm: 'phoneconfirm',
        cancel: 'cancel',
        expiry: 'expiry'
    }
};
